module.exports = __webpack_public_path__ + "img/logo.ff6e5923.png";